<template>
  <v-expansion-panels v-model="panel" multiple focusable class="mt-4 mb-14">
    <v-expansion-panel readonly>
      <v-expansion-panel-header hide-actions>
        <div class="text-center font-weight-bold">
          <v-row no-gutters>
            <v-col cols="2" class="text-left">Operador</v-col>
            <v-col cols="2" class="text-right pr-2">Total Chamadas</v-col>
            <v-col cols="1" class="text-right">Atendidas</v-col>
            <v-col cols="2" class="text-right">Não Atendidas</v-col>
            <v-col cols="1" class="text-left ml-7">TMC</v-col>
            <v-col cols="1" class="text-left ml-6">TMA</v-col>
            <v-col cols="1" class="text-left ml-5">TME</v-col>
          </v-row>
        </div>
      </v-expansion-panel-header>
    </v-expansion-panel>

    <v-expansion-panel
      v-for="(op, key) in operadores"
      :key="key"
      :readonly="openExpansionList"
    >
      <v-expansion-panel-header ripple>
        <v-row no-gutters>
          <v-col cols="2" class="text-left">{{
            op.operador
              .split("-")
              .reverse()
              .join(" - ")
          }}</v-col>
          <v-col cols="2" class="text-right">{{ getTotalChamadas(op) }}</v-col>
          <v-col cols="1" class="text-right ml-2">{{ op.atendidas }}</v-col>
          <v-col cols="2" class="text-right ml-1">{{ op.naoAtendidas }}</v-col>
          <v-col cols="1" class="text-left ml-8">{{
            op.mediaTempoDeChamada
          }}</v-col>
          <v-col cols="1" class="text-left ml-6">{{
            op.mediaTempoDeAtendimento
          }}</v-col>
          <v-col cols="1" class="text-left ml-6">{{ op.mediaEspera }}</v-col>
        </v-row>
        <template v-slot:actions>
          <v-icon :color="openExpansionList ? 'grey lighten-1' : 'orangePcm'"
            >$expand</v-icon
          >
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content color="background">
        <LayoutRelatorioResumido :operador="op" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import LayoutRelatorioResumido from "./LayoutRelatorioResumido";
export default {
  name: "ExpansionListOperadorDireto",
  components: { LayoutRelatorioResumido },
  props: {
    operadores: Array,
    panel: Array,
    openExpansionList: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getTotalChamadas(operador) {
      return operador.atendidas + operador.naoAtendidas;
    },
  },
};
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
